import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { TableError } from '../../types/common';
import { AwardAgreementDocumentImportService } from '../../services/wealthlane-award-services/services/AwardAgreementDocumentImportService';
import { Wealthlane_AwardService_Dtos_AwardDocumentDto_EditAwardDocumentDto } from '../../services/wealthlane-award-services';

const usePostEditAwardDoc = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onClose: () => void,
  onError: (message: string, errors: TableError[]) => void
): UseMutationResult<
  Array<Wealthlane_AwardService_Dtos_AwardDocumentDto_EditAwardDocumentDto>,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload) => {
      return await handleRequest(
        AwardAgreementDocumentImportService.postApiAwardApiAppAwardAgreementDocumentImportEditAwardDocument(
          payload
        )
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response !== null && response?.isSuccess) {
          onClose && onClose();
          toast.success(<ToastComponent label='Success' message={`Award Document Edited.`} />);
        } else {
          throw {
            message: response?.message,
            errors: response?.errors,
            error: new Error(),
          };
        }
        await queryClient.invalidateQueries('getAwardDocByAwardId');
        onClose && onClose();
      },
      onError: (err: any) => {
        console.log('error', err);
        onError && onError(err?.message, err?.errors);
        onClose && onClose();
      },
    }
  );
};

export default usePostEditAwardDoc;
